export default __webpack_public_path__ + "static/media/trylleby-property-16.a4577ec0.jpg";